import React from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from 'src/store/hooks'
import { selectUseAssignmentAnalytics } from 'src/v3/settings/settings.slice'
import AssignmentsList from './assignments-list'
import AssignmentAnalytics from '../assignment-analytics'

export default function AssignmentsWrapper() {
  let location = useLocation()
  let navigate = useNavigate()
  let useAssignmentAnalytics = useAppSelector(selectUseAssignmentAnalytics)

  let activeTab =
    location.pathname.includes('analytics') && useAssignmentAnalytics
      ? 'analytics'
      : 'list'

  let handleTabChange = (_: React.SyntheticEvent, newTab: string) => {
    navigate(
      newTab === 'analytics'
        ? '/manage/assignments/analytics'
        : '/manage/assignments',
    )
  }

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Assignments" value="list" />
        {useAssignmentAnalytics && (
          <Tab label="Assignment Analytics" value="analytics" />
        )}
      </Tabs>

      {activeTab === 'analytics' && useAssignmentAnalytics && (
        <AssignmentAnalytics />
      )}
      {activeTab === 'list' && <AssignmentsList />}
    </Box>
  )
}
